import React from "react";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer
} from "recharts";

const CustomTooltip = ({ active, payload, label, module }) => {
    if (active && payload && payload.length) {
        const data = payload[0]?.payload || {};
        return (
            <div className="custom-tooltip" style={{
                backgroundColor: '#fff',
                border: '1px solid #ccc',
                padding: '10px',
                whiteSpace: 'nowrap'
            }}>
                <p className="label" style={{ margin: '0 0 10px 0' }}>
                    {label}
                </p>
                {payload.map((entry, index) => (
                    <p key={`item-${index}`} style={{ margin: '5px 0', color: entry.color || '#8884d8' }}>
                        {entry.name} : <span style={{ color: entry.color || '#8884d8' }}>{entry.value !== null && entry.value !== undefined ? entry.value : '-'}</span>
                    </p>
                ))}
            </div>
        );
    }
    return null;
};

const barColors = [
    "#8884d8",
    "#82ca9d",
    "#f55b00",
    "#2c95d2",
    "#a52cd2",
    "#ff8800",
];

export default function BarChartComponent({ module, data, height, width, barState }) {
    return (
        <ResponsiveContainer width={"100%"} height={height}>
            <BarChart data={data}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis 
                    dataKey="name" 
                    padding={{ left: 30, right: 30 }}
                    angle={data?.length > 15 ? -45 : 0}
                    textAnchor={data?.length > 15 ? "end" : "middle"}
                    height={data?.length > 15 ? 60 : 30}
                    tickFormatter={(value) => value && value.length > 10 ? value.substring(0, 10) + '...' : value}
                />
                <YAxis
                    allowDecimals={false}
                    domain={module === "TeacherLoungeGraph" ? [0, dataMax => (Math.ceil(dataMax / 10) * 10) + 10] : ['auto', 'auto']}
                />
                <Tooltip content={<CustomTooltip module={module} />} cursor={{ fill: 'transparent' }} />
                <Legend />
                {module === "TeacherLoungeGraph" && (
                    <>
                        <Bar
                            dataKey="No. of Posts"
                            fill="#16627a"
                            radius={[4, 4, 0, 0]}
                            barSize={15}
                            isAnimationActive={false}
                            label={{ position: 'top', fill: '#cf5a24', fontSize: 12, fontWeight: 700 }}
                        />
                        <Bar
                            dataKey="Unique users (who have posted)"
                            fill="#e26a29"
                            radius={[4, 4, 0, 0]}
                            barSize={15}
                            isAnimationActive={false}
                            label={{ position: 'top', fill: '#333', fontSize: 12, fontWeight: 700 }}
                        />
                    </>
                )}
            </BarChart>
        </ResponsiveContainer>
    );
}
